import React, { FunctionComponent, useEffect } from 'react';
import { appSettings } from '@visalex/configs';
import { FormGroup, NullableSelectOption, Select, SelectOption, SelectProps } from '@visalex/forms';
import { useFormContext } from 'react-hook-form';

import { TFunction } from 'i18next';

import { createCaption } from './Caption';

export type FreeConsultationSelectProps = {
  t: TFunction;
  query: Record<string, string>;
  countries: Array<string>[];
  menuPortalProps: Partial<SelectProps>;
};

export const FreeConsultationSelect: FunctionComponent<FreeConsultationSelectProps> = ({
  query,
  t,
  countries,
  menuPortalProps,
}) => {
  const {
    register,
    setValue,
    formState: { errors },
  } = useFormContext();
  const countryList: SelectOption[] = [];
  let defaultValue: NullableSelectOption = null;

  countries.forEach((country: Array<string>) => {
    const option = { label: country[0], value: country[1] };

    if (country[1]) {
      countryList.push(option);
    }

    if (query.country === country[1]) {
      defaultValue = option;
    }
  });

  useEffect(() => {
    setValue('country', defaultValue);
  }, []);

  return (
    <FormGroup name="countrySelect" inline helper={createCaption(0, t)}>
      <div style={{ marginRight: 20, width: 300 }}>
        <Select
          name="countrySelect"
          valid={!errors.country}
          onChange={(newValue) => {
            const selectValue = newValue ? (newValue as SelectOption).value : '';

            const selectedCountry = newValue
              ? countries.find((country) => country[1] === (newValue as SelectOption).value)
              : [];

            setValue('country', selectValue, { shouldValidate: true });
            setValue(
              'nationality',
              selectedCountry && selectedCountry?.length
                ? { label: selectedCountry[2], value: selectedCountry[1] }
                : null
            );
          }}
          placeholder={t('free-consultation.please-select-country')}
          options={countryList}
          defaultValue={defaultValue}
          {...menuPortalProps}
        />
        <input
          {...register('country', {
            validate: (value: string) => !appSettings.bannedCountries.includes(value) || 'error',
            required: t('common.forms.validation.required'),
          })}
          type="hidden"
        />
      </div>
    </FormGroup>
  );
};
